import { render, staticRenderFns } from "./customerChat.vue?vue&type=template&id=5a66505e&scoped=true&"
import script from "./customerChat.vue?vue&type=script&lang=js&"
export * from "./customerChat.vue?vue&type=script&lang=js&"
import style0 from "./customerChat.vue?vue&type=style&index=0&id=5a66505e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a66505e",
  null
  
)

export default component.exports